import { trigger_interaction } from './Analytics';
import YearDropdown from './../../Components/YearDropdown';
//topics
export function selectAnotherQuestion() {
    trigger_interaction('QVIEW', 'o', 'Return');
}
export function selectLocation({ locationAbbr }) {
    trigger_interaction('QVIEW', 'o', `LOCATION, ${locationAbbr}`);
}
export function selectTable() {
    trigger_interaction('QVIEW', 'o', 'VIEW, TABLE');
}
export function selectMap() {
    trigger_interaction('QVIEW', 'o', 'VIEW, MAP');
}
export function selectGraph() {
    trigger_interaction('QVIEW', 'o', 'VIEW, GRAPH');
}
export function selectShareLink() {
    trigger_interaction('QVIEW', 'o', 'SHARE');
}
export function selectSubQuestion({ questionId, subQuestionId }) {
    trigger_interaction('QVIEW', 'o', `SUBQ, ${questionId}, ${subQuestionId}`);
}
export function selectExport({ exportType }) {
    trigger_interaction('QVIEW', 'o', `EXPORT, ${exportType}`);
}
export function selectBreadcrumbDestination({ destination }) {
    trigger_interaction('QVIEW', 'o', `BREADCRUMB, ${destination}`);
}
